var exports = {
  "l": "identifierText__e8FuO6",
};

module.exports = exports;
